// Copyright (c) 2021 Deere & Company

import './index.scss';

import AtpCalendar from './atpCalendar';
import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';

function AtpCalendarPage () {

    return (
        <AuthenticatedPage className="atp-page atp-calendar-page">
            <AtpCalendar />
        </AuthenticatedPage>
    );

}
AtpCalendarPage.displayNAme = 'AtpCalendarPage';

export default AtpCalendarPage;
